<div class="flex flex-column border-round-lg py-2 text-sm max-w-20rem">

  <div class="px-3 py-2 border-bottom-1 border-gray-400 flex align-items-center gap-1">
    <span class="font-medium white-space-nowrap"> MD5 :</span>
    <span class="text-ellipsis" tooltipStyleClass="w-full" [pTooltip]="headerData?.MD5" tooltipPosition="left">{{headerData?.MD5}}</span>
    <app-copy-content title="MD5" [content]="headerData.MD5"/>
  </div>

  @if(headerData.conversation_id) {
    <div class="px-3 py-2 border-bottom-1 border-gray-400 flex align-items-center gap-1">
      <span class="font-medium white-space-nowrap"> Conversation ID :</span>
      <span class="text-ellipsis" tooltipStyleClass="w-full" [pTooltip]="headerData?.conversation_id" tooltipPosition="left">{{headerData?.conversation_id}}</span>
      <app-copy-content title="Conversation ID" [content]="headerData.conversation_id"/>
    </div>
  }

  @if(headerData?.metaData?.['message-id']) {
    <div class="px-3 py-2 border-bottom-1 border-gray-400 flex align-items-center gap-1">
      <span class="font-medium white-space-nowrap"> Message ID :</span>
      <span class="text-ellipsis" tooltipStyleClass="w-full" [pTooltip]="headerData?.metaData?.['message-id']" tooltipPosition="left">{{headerData?.metaData?.['message-id']}}</span>
      <app-copy-content title="Message ID" [content]="headerData?.metaData?.['message-id']"/>
    </div>
  }

  @if(headerData?.metaData?.['thread-index']) {
    <div class="px-3 py-2 border-bottom-1 border-gray-400 flex align-items-center gap-1">
      <span class="font-medium white-space-nowrap"> Thread Index :</span>
      <span class="text-ellipsis" tooltipStyleClass="w-full" [pTooltip]="headerData?.metaData?.['thread-index']" tooltipPosition="left">{{headerData?.metaData?.['thread-index']}}</span>
      <app-copy-content title="Thread Index" [content]="headerData?.metaData?.['thread-index']"/>
    </div>
  }

  @if(headerData.readHistory === undefined) {
    <div class="px-3 py-2 font-medium border-gray-400">Read by none</div>
  } @else if(isCurrentUserRead(headerData.readHistory) && otherReadUsersCount(headerData.readHistory) <= 0) {
    <div class="px-3 py-2 font-medium border-gray-400">Read by you</div>
  } @else if(!isCurrentUserRead(headerData.readHistory) && otherReadUsersCount(headerData.readHistory) >= 1) {
    <div class="px-3 py-2 font-medium border-gray-400 flex justify-content-between align-items-center gap-1 cursor-pointer" (click)="showReadHistory = !showReadHistory">
      <span>Read by {{otherReadUsersCount(headerData.readHistory)}} user(s)</span>
      <i [class]="'pi ' + (showReadHistory ? ' pi-chevron-up ' : ' pi-chevron-down ') " [style.fontSize]="'0.9rem'"></i>
    </div>
  } @else if(isCurrentUserRead(headerData.readHistory) && otherReadUsersCount(headerData.readHistory) > 0) {
    <div class="px-3 py-2 font-medium border-gray-400 flex justify-content-between align-items-center gap-1 cursor-pointer"  (click)="showReadHistory = !showReadHistory">
      <span>Read by you and {{otherReadUsersCount(headerData.readHistory)}} more user(s)</span>
      <i [class]=" 'pi ' + (showReadHistory ? ' pi-chevron-up' : ' pi-chevron-down ') " [style.fontSize]="'0.9rem'"></i>
    </div>
  }

  @if(headerData.readHistory && objectKeys(headerData.readHistory).length && showReadHistory) {
    <div class="max-h-8rem overflow-y-scroll overflow-x-hidden ">
      @for(user of objectKeys(headerData.readHistory); track user) {
        <div class="px-3 pb-1 white-space-nowrap overflow-hidden text-overflow-ellipsis text-gray-700">
          {{user}}
        </div>
      }
    </div>
  }
</div>
